const GaTrackingIds: {
  [key: string]: string[];
} = {};

const FacebookPixelIds: {
  [key: string]: string;
} = {};

const TwitterPixelIds: {
  [key: string]: string;
} = {};

const TiktokPixelIds: {
  [key: string]: string;
} = {};

const TradeDeskIds: {
  [key: string]: string[]; // By convention, first element is the advertiserId, the rest is segment id
} = {};

const RedditPixelIds: {
  [key: string]: string;
} = {};

const ClubData: {
  [key: string]: { club_id: number; club_name: string };
} = {};

GaTrackingIds["brewers"] = ["DC-2946534"];
GaTrackingIds["frontwavearena"] = ["AW-11394969496"];
GaTrackingIds["gamecocks"] = ["G-VZH9W38TYJ"];
GaTrackingIds["la-kings"] = ["AW-16733286784", "DC-17169978"];
GaTrackingIds["reign"] = ["AW-328056858"];
// DBH Teams
GaTrackingIds["greenjackets"] = ["G-VZWNSQ7WD5"];
GaTrackingIds["barons"] = ["G-VHJ0SS2VTD"];
GaTrackingIds["cyclones"] = ["G-CCWJ3PHJ9C"];
GaTrackingIds["clingstones"] = ["G-32LJ0662JB"];
GaTrackingIds["cchooks"] = ["G-6DZE8R05WS"];
GaTrackingIds["woodpeckers"] = ["G-3PB7ZKTKGT"];
GaTrackingIds["fresnogrizzlies"] = ["G-CMQ6K9Y9ST"];
GaTrackingIds["stripers"] = ["G-QME7GHZLRY", "AW-17990393653"];
GaTrackingIds["senators"] = ["G-7V2KYF7HBK"];
GaTrackingIds["crawdads"] = ["G-LM65SCMQ6Z"];
GaTrackingIds["spartanburgers"] = ["G-WL4M9Y3SCB", "AW-17960072554"];
GaTrackingIds["66ers"] = ["G-6H2B6L0STH"];
GaTrackingIds["bats"] = ["G-LDVQ5TDP0N"];
GaTrackingIds["redbirds"] = ["G-97GL54CEL0"];
GaTrackingIds["rockhounds"] = ["G-TK3TB9B1VX"];
GaTrackingIds["fishercats"] = ["G-CKERY3E1QF", "AW-16853552450"];
GaTrackingIds["towerbuzzers"] = ["G-NWD3ZLRZ08"];
GaTrackingIds["seadogs"] = ["G-HBHG8ES33G"];
GaTrackingIds["rcquakes"] = ["G-BGWV4BKXRL", "AW-16853677002"];
GaTrackingIds["emperors"] = ["G-2WMZ8CF5ND"];
GaTrackingIds["ridgeyaks"] = ["G-Z9BC2THHLE"];
GaTrackingIds["railriders"] = ["G-Z0WK7F97FM"];
GaTrackingIds["saintsbaseball"] = ["G-FR3VX7P3HD"];
GaTrackingIds["spacecowboys"] = ["G-0X1P1D155N"];
GaTrackingIds["syracusemets"] = ["G-TJ28FD6F7L"];
GaTrackingIds["dustdevils"] = ["G-NJ4H9ETESQ"];
GaTrackingIds["windsurge"] = ["AW-978300184", "G-7Z1022D3QR"];
GaTrackingIds["timberrattlers"] = ["G-7BWZ9X7WPK"];
GaTrackingIds["woosox"] = ["G-N23Q41ZPTD"];
GaTrackingIds["rumbleponies"] = ["G-2FSYYDWDZ5"];
GaTrackingIds["hvrenegades"] = ["G-SXTLJXG3HJ"];
GaTrackingIds["lugnuts"] = ["G-GZ903VY5XD"];
GaTrackingIds["emperors"] = ["G-2WMZ8CF5ND"];
GaTrackingIds["charlotteknights"] = ["AW-17997896297﻿"];

FacebookPixelIds["brewers"] = "2892474421069407";
FacebookPixelIds["frontwavearena"] = "1041852372858187";
FacebookPixelIds["gamecocks"] = "799264502421457";
FacebookPixelIds["la-kings"] = "1201822627599125";
FacebookPixelIds["reign"] = "171994126573408";
FacebookPixelIds["remix"] = "548254070716126";
FacebookPixelIds["fresnogrizzlies"] = "1736516757278123";
FacebookPixelIds["66ers"] = "542601775586004";
FacebookPixelIds["greenjackets"] = "3596561407316694";
FacebookPixelIds["barons"] = "1959251398225406";
FacebookPixelIds["crawdads"] = "1535157757816491";
FacebookPixelIds["woosox"] = "879589284498232";
FacebookPixelIds["towerbuzzers"] = "2866144817044869";
FacebookPixelIds["cyclones"] = "1348382813638376";
FacebookPixelIds["saintsbaseball"] = "1636279987686787";
FacebookPixelIds["jumboshrimp"] = "618606964238723";
FacebookPixelIds["rubberducks"] = "879255388270477";
FacebookPixelIds["fishercats"] = "1315840137074358";
FacebookPixelIds["stormers"] = "2823581504513753";
FacebookPixelIds["spartanburgers"] = "929024683181784";
FacebookPixelIds["rcquakes"] = "1841952906483496";
FacebookPixelIds["stripers"] = "2682491372287450";
FacebookPixelIds["bats"] = "838966738484072";
FacebookPixelIds["railriders"] = "1228849866128221";
FacebookPixelIds["hvrenegades"] = "1651463112566511";
FacebookPixelIds["frednats"] = "26348666674741901";
FacebookPixelIds["okccomets"] = "1365623718928238";
FacebookPixelIds["stormchasers"] = "4414024565583081";
FacebookPixelIds["windsurge"] = "1683444239541793";
FacebookPixelIds["charlotteknights"] = "1500118543530557";
FacebookPixelIds["drillers"] = "995355793254886";

TwitterPixelIds["gamecocks"] = "nxkro";

TiktokPixelIds["la-kings"] = "CUSDOQBC77UCOV2DUTKG";
TiktokPixelIds["barons"] = "D76JKS3C77UBIUFU00D0";

TradeDeskIds["fresnogrizzlies"] = ["aszns79", "e187lw7"];
TradeDeskIds["66ers"] = ["dp1o1s6", "cahoj3d"];
TradeDeskIds["la-kings"] = ["q5084g4", "l4e1pen"];

RedditPixelIds["woosox"] = "a2_imfmf9e40ven";

ClubData["greenjackets"] = { club_id: 3, club_name: "Augusta GreenJackets" };
ClubData["barons"] = { club_id: 5, club_name: "Birmingham Barons" };
ClubData["cyclones"] = { club_id: 44, club_name: "Brooklyn Cyclones" };
ClubData["clingstones"] = { club_id: 126, club_name: "Columbus Clingstones" };
ClubData["cchooks"] = { club_id: 54, club_name: "Corpus Christi Hooks" };
ClubData["woodpeckers"] = {
  club_id: 64,
  club_name: "Fayetteville Woodpeckers",
};
ClubData["fresnogrizzlies"] = { club_id: 7, club_name: "Fresno Grizzlies" };
ClubData["stripers"] = { club_id: 8, club_name: "Gwinnett Stripers" };
ClubData["senators"] = { club_id: 9, club_name: "Harrisburg Senators" };
ClubData["crawdads"] = { club_id: 10, club_name: "Hickory Crawdads" };
ClubData["spartanburgers"] = {
  club_id: 127,
  club_name: "Hub City Spartanburgers",
};
ClubData["hvrenegades"] = { club_id: 11, club_name: "Hudson Valley Renegades" };
ClubData["66ers"] = { club_id: 12, club_name: "Inland Empire 66ers" };
ClubData["bats"] = { club_id: 15, club_name: "Louisville Bats" };
ClubData["redbirds"] = { club_id: 16, club_name: "Memphis Redbirds" };
ClubData["rockhounds"] = { club_id: 17, club_name: "Midland RockHounds" };
ClubData["fishercats"] = {
  club_id: 19,
  club_name: "New Hampshire Fisher Cats",
};
ClubData["towerbuzzers"] = { club_id: 378, club_name: "Ontario Tower Buzzers" };
ClubData["seadogs"] = { club_id: 22, club_name: "Portland Sea Dogs" };
ClubData["rcquakes"] = { club_id: 95, club_name: "Rancho Cucamonga Quakes" };
ClubData["emperors"] = { club_id: 23, club_name: "Rome Emperors" };
ClubData["ridgeyaks"] = { club_id: 24, club_name: "Salem RidgeYaks" };
ClubData["railriders"] = {
  club_id: 26,
  club_name: "Scranton Wilkes-Barre RailRiders",
};
ClubData["saintsbaseball"] = { club_id: 28, club_name: "St. Paul Saints" };
ClubData["spacecowboys"] = {
  club_id: 110,
  club_name: "Sugar Land Space Cowboys",
};
ClubData["syracusemets"] = { club_id: 111, club_name: "Syracuse Mets" };
ClubData["dustdevils"] = { club_id: 116, club_name: "Tri-City Dust Devils" };
ClubData["windsurge"] = { club_id: 31, club_name: "Wichita Wind Surge" };
ClubData["timberrattlers"] = {
  club_id: 120,
  club_name: "Wisconsin Timber Rattlers",
};
ClubData["woosox"] = { club_id: 33, club_name: "Worcester Red Sox" };

export function getTrackingIdsBySubdomain(subdomain: string) {
  if (!GaTrackingIds[subdomain]) {
    return [];
  }
  return GaTrackingIds[subdomain];
}

export function getFacebookPixelIdBySubdomain(subdomain: string) {
  if (!FacebookPixelIds[subdomain]) {
    return "";
  }
  return FacebookPixelIds[subdomain];
}

export function getTwitterPixelIdBySubdomain(subdomain: string) {
  if (!TwitterPixelIds[subdomain]) {
    return "";
  }
  return TwitterPixelIds[subdomain];
}

export function getTiktokPixelIdBySubdomain(subdomain: string) {
  if (!TiktokPixelIds[subdomain]) {
    return "";
  }
  return TiktokPixelIds[subdomain];
}

export function getTradeDeskIdBySubdomain(subdomain: string) {
  if (!TradeDeskIds[subdomain]) {
    return [];
  }
  return TradeDeskIds[subdomain];
}

export function getRedditPixelIdBySubdomain(subdomain: string) {
  if (!RedditPixelIds[subdomain]) {
    return "";
  }
  return RedditPixelIds[subdomain];
}

export function getClubDataBySubdomain(subdomain: string) {
  return ClubData[subdomain] ?? null;
}
